
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.001","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1953"}},[_c('path',{attrs:{"data-name":"Rectangle 2683","fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"data-name":"Group 1952"}},[_c('path',{attrs:{"data-name":"Path 1268","d":"M23.001 10h-9V1a1 1 0 00-1-1h-12a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1V11a1 1 0 00-1-1zm-21-8h2v2h-2zm2 19.957h-2v-2h2zm2 .043v-3.041a1 1 0 00-1-1h-3V6h3a1 1 0 001-1V2h6v8h-3a1 1 0 000 2h3v3a1 1 0 002 0v-3h8v5.959h-3a1 1 0 00-1 1v3.043h-12zm16-.043h-2v-2h2z","fill":"#adadad"}})])])])
          )
        }
      }
    